import React, { useEffect } from 'react';
import useEventForm from './hooks/useEventForm';
import './CreaEvento.css';

const buildInitialData = (evento, aziendaId) => ({
  titolo: evento?.titolo || '',
  descrizione: evento?.descrizione || '',
  immagineCopertina: null,
  fileName: evento?.copertinaName || null,
  idAzienda: evento?.idAzienda || aziendaId,
});

const CreaTradizioni = ({ evento, azienda, onFormSubmit }) => {
  const { formData, setFormData, handleChange } = useEventForm(
    buildInitialData(evento, azienda)
  );

  useEffect(() => {
    setFormData(buildInitialData(evento, azienda));
  }, [evento, azienda, setFormData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Titolo:
        <input type="text" name="titolo" value={formData.titolo} onChange={handleChange} />
      </label>
      <br />
      <label>
        Descrizione:
        <input
          type="text"
          name="descrizione"
          value={formData.descrizione}
          onChange={handleChange}
        />
      </label>
      <br />
      <label>
        Immagine di Copertina:
        <input type="file" name="immagineCopertina" accept="image/*" onChange={handleChange} />
        {formData.fileName && <p>File selezionato: {formData.fileName}</p>}
      </label>
      <button type="submit">Invia</button>
    </form>
  );
};

export default CreaTradizioni;
